import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { cardStyle } from '@/styles/style';

import { VFlex } from '../base';

type Props = {
  header: ReactNode;
  body: ReactNode;
  style?: CSSProperties;
  className?: string;
};

const Card = (props: Props) => {
  return (
    <Style style={props.style} className={props.className}>
      {props.header}
      {props.body}
    </Style>
  );
};

const CardHeaderStyle = styled(VFlex)`
  padding: 24px;
  background-color: ${(props) => props.theme.colors.gray250};
  border-radius: 0 0 16px 16px;
  height: 124px;
`;

const Style = styled(VFlex)`
  ${cardStyle};
`;

Card.CardHeaderStyle = CardHeaderStyle;
export default Card;
